import getDashboardIfFromUrl from './utils/getDashboardIfFromUrl';
import isYouTubeUrl from './utils/isYouTubeUrl';
import keyCodes from './utils/keyCodes';
import moment from 'moment-timezone';

// eslint-disable-next-line no-magic-numbers
const dashboardLoadMaxDelay = 20 * 1000;

const Slides = {
	currentSlide: null,
	currentSlideContainer: null,
	nextSlideTimeout: null,
	animateTimeout: null,
	animateFinishedTimeout: null,
	manualNextTimeout: null,
	enabled: true,
	currentlyLoadingDashboard: null,
	dashboardLoadedCallback: null,

	init: function(initial) {
		this.enabled = true;
		this.nextSlide(false, initial);

		// next slide keyboard shortcut
		const that = this;
		const prevSlideKeys = [
			keyCodes.up,
			keyCodes.left,
		];
		const nextSlideKeys = [
			keyCodes.space,
			keyCodes.enter,
			keyCodes.right,
			keyCodes.down,
		];
		$(window).on('keyup.slides', function(e) {
			if (nextSlideKeys.indexOf(e.keyCode) >= 0) {
				that.manualNextSlide();
			} else if (prevSlideKeys.indexOf(e.keyCode) >= 0) {
				that.manualPrevSlide();
			}
		});
	},

	destroy: function() {

		// clear any timeouts, unbind events and reset variables
		this.enabled = false;
		clearTimeout(this.nextSlideTimeout);
		clearTimeout(this.animateTimeout);
		clearTimeout(this.animateFinishedTimeout);
		clearTimeout(this.manualNextTimeout);
		$(window).off('keyup.slides');
		this.currentSlide = null;
		this.currentSlideContainer = null;
		this.nextSlideTimeout = null;
		Screen.elements.slides.html('');
	},

	manualPrevSlide: function() {
		if (Screen.isLoading) {

			// pass
		} else {
			Screen.showLoading();
			this.nextSlide(true);
		}
	},

	manualNextSlide: function() {
		if (Screen.isLoading) {

			// pass
		} else {
			Screen.showLoading();
			this.nextSlide();
		}
	},

	getRandomInt: function(min, max) {
		return Math.floor(Math.random() * (max - min + 1)) + min;
	},

	getCurrentSlideTheme: function() {
		let dashboardSettings = null;
		try {
			dashboardSettings = this.currentSlideContainer.find('iframe')[ 0 ].contentWindow.AppSettings;
		} catch (e) {

			// pass on same-origin error
		}
		if (dashboardSettings) {
			return dashboardSettings.theme;
		}
	},

	nextSlide: function(backwards, initialSlide) {
		backwards = backwards ? backwards : false;
		clearTimeout(this.nextSlideTimeout);
		const that = this;
		this.requestNextSlide(backwards, function(slide) {
			// eslint-disable-next-line no-undef
			log('got slide with url ' + slide[ 'slide_url' ]);
			if (
				!that.currentSlide ||
					(that.currentSlide &&
					slide['slide_url'] !== that.currentSlide['slide_url'])
			) {
				// only show new slide if the url changed
				that.showSlide(
					backwards,
					initialSlide,
					slide['slide_url'],
					slide['mute_video'],
					function() {
						that.currentSlide = slide;
					}
				);
			} else {
				// eslint-disable-next-line no-undef
				log('same url received, skipped');
				Screen.hideLoading();
			}
			
			if ('number_of_slides' in slide && slide['number_of_slides'] <= 1) {
				Screen.hideSlideControls();
			} else {
				Screen.showSlideControls();
			}
			that.queueNextRequest(slide[ 'slide_duration' ]);
		});
	},

	nextSlideTimeMsg: function(next_time) {
		const that = this;
		const nextTimeFormatted = moment(next_time, 'HH:mm:ss').format('HH:mm');

		// eslint-disable-next-line max-len
		Screen.elements.error.html('<p class="error-center error-lg">Next slide will be available at ' + nextTimeFormatted + '</p>');
		Screen.elements.error.show();

		// eslint-disable-next-line no-magic-numbers
		that.queueNextRequest(that.getRandomInt(20, 40));
	},

	requestNextSlide: function(backwards, callback) {
		const that = this;
		let method = 'GET';
		let postData = null;
		if (this.currentSlide) {
			method = 'POST';
			postData = { previous_slide_id: this.currentSlide[ 'slide_id' ] };
		}
		if (Screen.options.screenId) {
			let url = Screen.options.apiUrlPrefix + Screen.options.screenId;
			if (backwards) {
				url += Screen.options.apiUrlSuffixPrevious;
			} else {
				url += Screen.options.apiUrlSuffix;
			}
			$.ajax({
				type: method,
				contentType: 'application/json; charset=utf-8',
				url: url,
				dataType: 'json',
				data: JSON.stringify(postData),
				beforeSend: function(request) {
					if (Screen.options.publicUrlToken) {
						request.setRequestHeader('publicUrlToken', Screen.options.publicUrlToken);
					}
				},
				success: function(data) {
					if (that.enabled) {
						if (data[ 'slide_id' ]) {
							callback(data);
						} else {
							that.currentSlide = null;  // reset current slide
							if (data.next_time) {
								that.nextSlideTimeMsg(data.next_time);
							} else {
								Screen.throwError('No slides available! Please select some slides for this screen.');
							}
						}
					}
				},
				error: function(e) {
					// eslint-disable-next-line no-magic-numbers
					that.queueNextRequest(that.getRandomInt(15, 20));
				},
				statusCode: {
					403: function() {
						Screen.throwError('Failed requesting next slide! Forbidden');
					},
					404: function() {
						Screen.throwError('Failed requesting next slide! Not Found');
					}
				}
			});
		} else {

			// randomly select a slide for the demo
			const index = this.getRandomInt(0, Screen.options.demoSlides.length - 1);
			callback(Screen.options.demoSlides[ index ]);
		}
	},

	queueNextRequest: function(duration) {
		// eslint-disable-next-line no-magic-numbers
		duration =  duration || 30;
		log('queued next request', duration);
		clearTimeout(this.nextSlideTimeout);
		const that = this;
		this.nextSlideTimeout = setTimeout(function() {
			that.nextSlide();
		// eslint-disable-next-line no-magic-numbers
		}, duration * 1000);
	},

	showSlide: function(backwards, initialSlide, url, muteVideo, callback) {
		callback = callback ? callback : function() {};
		const that = this;
		Screen.hideError();
		const container = Screen.elements.slides;
		const oldIframe = container.find('.iframe');
		oldIframe.css('left', '0%');
		const newIframe = $('<iframe allow="autoplay; fullscreen"></iframe>');
		const mute = muteVideo ? 1 : 0;
		// Validate Youtube url
		const youtubeUrl = isYouTubeUrl(url);
		if (youtubeUrl) {
			url = 'https://www.youtube.com/embed/' +
				youtubeUrl.video_id +
				'?autoplay=1&loop=1&mute=' + mute + '&controls=0&playlist=' +
				youtubeUrl.video_id;
		}
		newIframe.attr('src', url);
		const newIframeCont = $('<div class="iframe"></div>');
		newIframeCont.append(newIframe);
		let newPos = '100%';
		if (backwards) {
			newPos = '-100%';
		}
		newIframeCont.css('left', newPos);
		container.append(newIframeCont);

		const dashboardId = getDashboardIfFromUrl(url);

		if (dashboardId && !initialSlide) {
			that.currentlyLoadingDashboard = dashboardId;
			const animateFunc = () => {
				that.animateSlide(backwards, oldIframe, newIframeCont, callback);
				if (that.currentlyLoadingDashboard === dashboardId) {
					that.dashboardLoadedCallback = null;
					that.currentlyLoadingDashboard = null;
				}
			};

			that.dashboardLoadedCallback = animateFunc;
			this.animateTimeout = setTimeout(animateFunc, dashboardLoadMaxDelay);
		} else {
			this.animateTimeout = setTimeout(function() {
				that.animateSlide(backwards, oldIframe, newIframeCont, callback);
			}, Screen.options.loadDelay);
		}

	},

	animateSlide: function(backwards, oldSlide, newSlide, callback) {
		Screen.hideLoading();

		let oldPos = '-100%';
		if (backwards) {
			oldPos = '100%';
		}
		if (oldSlide.length) {
			oldSlide.animate({ left: oldPos }, Screen.options.animationSpeed, function() {
				oldSlide.remove();
			});
			newSlide.animate({ left: '0%' }, Screen.options.animationSpeed);
		} else {
			newSlide.css('left', '0%');
		}
		const that = this;
		this.animateFinishedTimeout = setTimeout(function() {
			that.currentSlideContainer = newSlide;
			callback();
		}, Screen.options.animationSpeed);
	},

	onDashboardLoaded: function(dashboardId) {
		if (this.currentlyLoadingDashboard === dashboardId && this.dashboardLoadedCallback) {
			this.dashboardLoadedCallback();
			clearTimeout(this.animateTimeout);
		}
	}
};

export default Slides;
